"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Html, Image } from "@custom/schema";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import React, { useState } from "react";
var authorLabelSingle = /*#__PURE__*/ React.createElement(React.Fragment, null, "Author");
var authorLabelPlural = /*#__PURE__*/ React.createElement(React.Fragment, null, "Authors");
export default function AuthorSection(param) {
    var blogAuthors = param.blogAuthors;
    return /*#__PURE__*/ React.createElement("div", {
        className: "mb-6 md:mb-12"
    }, blogAuthors.length ? /*#__PURE__*/ React.createElement("h4", {
        className: "text-lg lg:text-xl font-medium font-heading mb-5"
    }, blogAuthors.length === 1 ? authorLabelSingle : authorLabelPlural) : null, blogAuthors.map(function(author, index) {
        var _author_linkedinUrl, _author_twitterUrl;
        return author ? /*#__PURE__*/ React.createElement("div", {
            key: index,
            className: "mb-6 last:mb-0"
        }, /*#__PURE__*/ React.createElement(AuthorBlock, {
            name: author.name,
            authorImage: author.image,
            biography: author.biography,
            linkedinUrl: (_author_linkedinUrl = author.linkedinUrl) === null || _author_linkedinUrl === void 0 ? void 0 : _author_linkedinUrl.text,
            twitterUrl: (_author_twitterUrl = author.twitterUrl) === null || _author_twitterUrl === void 0 ? void 0 : _author_twitterUrl.text
        })) : null;
    }));
}
function AuthorBlock(param) {
    var biography = param.biography, name = param.name, linkedinUrl = param.linkedinUrl, twitterUrl = param.twitterUrl, authorImage = param.authorImage;
    var _useState = _sliced_to_array(useState(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var toggleAccordion = function() {
        setIsOpen(function(prevState) {
            return !prevState;
        });
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "flex gap-x-4 mb-3.5 items-center"
    }, authorImage ? /*#__PURE__*/ React.createElement(Image, {
        source: authorImage.source,
        alt: authorImage.alt,
        className: "w-14 lg:w-20 rounded-full shrink-0 overflow-hidden border-2 border-b-gray-400"
    }) : null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("span", {
        className: "block lg:text-lg"
    }, name), /*#__PURE__*/ React.createElement("div", {
        className: "inline-flex items-baseline gap-x-5"
    }, linkedinUrl && /*#__PURE__*/ React.createElement("a", {
        href: "".concat(linkedinUrl),
        className: "block mt-2"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "Linkedin"), /*#__PURE__*/ React.createElement("img", {
        src: "/images/Med.png",
        alt: "linkedin icon",
        className: "w-4 lg:w-[18px]"
    })), twitterUrl && /*#__PURE__*/ React.createElement("a", {
        href: "".concat(twitterUrl),
        className: "block mt-2"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "Twitter"), /*#__PURE__*/ React.createElement("img", {
        src: "/images/twitter_icon.png",
        alt: "Twitter icon",
        className: "w-4 lg:w-[18px]"
    }))))), biography && /*#__PURE__*/ React.createElement("div", {
        className: "flex gap-x-5 items-start"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "accordion-content overflow-hidden transition-all ".concat(isOpen ? "max-h-[1000px]" : " max-h-12")
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-sm lg:text-base accordion-inner text-gray-900 content-text"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "".concat(isOpen ? "" : "line-clamp-2")
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: biography
    })))), /*#__PURE__*/ React.createElement("button", {
        onClick: toggleAccordion
    }, /*#__PURE__*/ React.createElement(ChevronDownIcon, {
        className: clsx("w-7 relative -top-px", {
            "rotate-180": isOpen
        })
    }))));
}
